const state = {
    title: null,    
};


const actions = {
    updateTitle({ commit }, title) {
        commit('updateTitle', title);
    }
};

const mutations = {
    updateTitle(state, title) {
        state.title = title;
        
    }    
};

export const title = {
    namespaced: true,
    state,
    actions,
    mutations
};
